import { Search } from "semantic-ui-react";

interface IBWSearchBoxProps {
  isGreaterThanMobile?;
  short?;
  placeHolder?: string;
  handleChange?: (e: any) => any;
  value?: string;
}

const BCSearchBox = ({ ...props }: IBWSearchBoxProps) => {
  return (
    <Search
      open={false}
      onSearchChange={props.handleChange}
      placeholder={props.placeHolder || "Search"}
      className={props.short ? "bc-search-input-short" : ""}
      value={props.value}
    />
  );
};

export default BCSearchBox;